import { useCallback, useState } from "react";
import { AuthApi } from "../../infrastructure/api/AuthApi";

/** Final step of change password; the temp token comes from useStepUpVerification. */
export const useChangePassword = () => {
  const [loading, setLoading] = useState(false);

  const changePassword = useCallback(
    async (oldPassword: string, newPassword: string, tempAccessToken: string) => {
      setLoading(true);
      try {
        await new AuthApi().changePassword(oldPassword, newPassword, tempAccessToken);
      } finally {
        setLoading(false);
      }
    },
    [],
  );

  return { changePassword, loading };
};
